<script lang="ts" setup>
import constants from '~/constants'
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

const props = defineProps<{
  current: string
  items: BreadcrumbsItem[]
}>()

useHead(() => {
  const { current, items } = props
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((x: BreadcrumbsItem, i: number): object => ({
      '@type': 'ListItem',
      item: `${constants.siteUrl}${x.path === '/' ? '' : x.path}`,
      name: x.name,
      position: i + 1
    }))
  }

  jsonLd.itemListElement.push({ '@type': 'ListItem', name: current, position: items.length + 1 })

  return {
    script: [
      {
        innerHTML: JSON.stringify(jsonLd),
        key: 'breadcrumbs-json-ld',
        type: 'application/ld+json'
      }
    ]
  }
})
</script>

<template>
  <ul class="breadcrumbs mb-8 flex flex-wrap md:-mt-6 md:mb-10">
    <li v-for="x in items" :key="x.path" class="breadcrumbs__item">
      <NuxtLink :to="x.path">
        <span>{{ x.name }}</span>
      </NuxtLink>
    </li>

    <li class="breadcrumbs__item breadcrumbs__item_current">
      <span>{{ current }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.breadcrumbs {
  $color: color.mix(variables.$main-gray-color, white, 40%);

  &__item {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }

    &:not(&_current) > a {
      color: $color;
    }

    & + &:before {
      color: $color;
      content: '/';
      display: inline-block;
      margin-right: 8px;
    }
  }
}
</style>
